<template>
  <div class="subscribe">
    <div class="container">
      <h2 class="title_font2">{{subscribe_title}}</h2>
      <p class="page_text_font">{{subscribe_description}}</p>
      <v-line></v-line>
      <div class="errors" v-if="errors.email">
        <ul class="page_text_font">
          <li>Email contains an invalid domain name.</li>
        </ul>
      </div>
      <form id="myform" @submit.prevent="subscribe_method()">
        <div class="emailaddress">
          <input
            v-if="!search_query.customer_posted"
            type="email"
            class="page_text_font"
            :placeholder="$t('index.your_email')"
            v-model="email"
          />
          <button
            v-if="!search_query.customer_posted"
            class="button secondary_title main_button"
            :class="[this.loading?'button_active':'',themeStyleRadius == 'circle' ? 'button-radius' : '']"
            type="submit"
          >{{$t('index.subscribe')}}</button>
          <i v-else>{{$t('thanks.subscribing')}}</i>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
// import API from "../../API";
export default {
  props: ["subscribe_title", "subscribe_description"],
  data() {
    return {
      email: "",
      customer_posted: "",
      search_query: {
        customer_posted: false
      },
      errors: {
        email: ""
      },
      loading: false
    };
  },
  computed: {
    ...mapState({
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    })
  },
  methods: {
    async subscribe_method() {
      try {
        this.loading = true;
        let res = await this.$axios.post(API.subscribe, { email: this.email });
        console.log(res);
        if (res.data && res.data.challenge) {
          res.data.type = "contact_form";
          sessionStorage.setItem("challenge", JSON.stringify(res.data));
          window.open("/challenge", "_self");
          setTimeout(() => {
            this.loading = false;
          }, 5000);
        } else {
          this.search_query.customer_posted = true;
          this.loading = false;
          this.errors = {};
          window.history.replaceState({}, "", "?customer_posted=true");
        }
        if (window.snaptr) {
          window.snaptr('track', 'PAGE_VIEW')
          window.snaptr('track', 'SUBSCRIBE')
        }
      } catch (error) {
        this.loading = false;
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        } else if (error?.response?.data?.message) {
          this.$message(error.response.data.message);
        }
      }
    }
  },
  beforeMount() {
    if (window.location.search) {
      let search = window.location.search.split("?")[1];
      if (search) {
        search.split("&").forEach(item => {
          this.search_query[item.split("=")[0]] = item.split("=")[1];
        });
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.subscribe {
  margin-top: 80px;
  margin-bottom: 40px;
  padding: 80px 0;
  background-color: #f6f6f6;
  text-align: center;

  h2 {
    font-size: 26px;
    margin-bottom: 10px;
  }

  p {
    margin: 10px auto 20px;
    font-size: 15px;
    color: #000;
    font-weight: 400;
    font-style: normal;
  }
  hr {
    display: block;
    margin: 20px auto 40px;
  }
  .errors {
    width: 520px;
    margin: 0 auto;
    background-color: #fff6f6;
    border: 1px solid #d02e2e;
    padding: 6px 12px;
    ul {
      margin: 0;
      padding-left: 20px;
      li {
        text-align: left;
        color: #d02e2e;
        font-size: 13.5px;
      }
    }
  }
  .emailaddress {
    width: 520px;
    margin: 0 auto;
    background: white;
    padding: 10px;
    text-align: left;
    display: flex;
    i {
      flex: 1;
      padding: 6px 12px;
      color: #56ad6a;
      background-color: #ecfef0;
      border: 1px solid #56ad6a;
      font-style: normal;
      font-size: 13.5px;
    }
    input {
      width: 5px;
      height: 45px;
      padding: 8px 10px;
      border: none;
      color: black;
      font-size: 20px;
      font-weight: normal;
      box-sizing: border-box;
      vertical-align: top;
      flex: 1;
      &:focus {
        padding: 6px 10px;
      }
    }

    input::-webkit-input-placeholder {
      color: black;
    }

    input::-moz-input-placeholder {
      color: black;
    }

    input::-ms-input-placeholder {
      color: black;
    }

    .button {
      border: none;
      display: inline-block;
      height: 45px;
      padding: 12px 20px;
      background-color: #c90d0d;
      color: white;
      cursor: pointer;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      border-radius: 0;
      letter-spacing: 0.1em;
      &:hover {
        background-color: rgb(241, 34, 34) !important;
      }
    }
    .button_active {
      position: relative;
      color: rgb(201, 13, 13) !important;
    }
  }
}
@media screen and (max-width: 590px) {
  .subscribe {
    .errors {
      width: 90%;
    }
    .emailaddress {
      width: 90%;
      .button {
        &::after {
          content: "→";
          font-weight: 600;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .subscribe {
    margin-top: 40px;
  }
}
</style>
